import React, { FunctionComponent } from "react";
import { Alert, Box } from "@mui/material";

import { Document } from "../../types";
import { Categories } from "../../context/ConfigContext/types";

import CardItem from "../CardItem";
import SkeletonCard from "../CardItem/SkeletonCard";

import "./DocumentLayout.css";

interface DocumentLayoutProps {
	documents: Document[];
	isLoading: boolean;
	categories: Categories;
	numericLabels: Categories;
}

const DocumentLayout: FunctionComponent<DocumentLayoutProps> = ({
	documents,
	isLoading,
	categories,
	numericLabels,
}) => {
	return (
		<Box className="card-grid">
			{(isLoading || Boolean(documents.length)) &&
				(isLoading ? Array.from(new Array(12)) : documents).map(
					(result: Document, index) => {
						return (
							<Box key={index} className="card">
								{result ? (
									<CardItem
										item={result}
										categories={categories}
										numericLabels={numericLabels}
									/>
								) : (
									<SkeletonCard />
								)}
							</Box>
						);
					}
				)}
		</Box>
	);
};

export default DocumentLayout;
